import { FaFolderOpen, FaPhone, FaCalendarCheck, FaUserCheck, FaFileInvoiceDollar, FaFileSignature, FaCheckCircle, FaTimesCircle } from 'react-icons/fa';

// Records Per Page in Table
export const RECORDS_PER_PAGE = 100;

export const RECORDS_PER_PAGE_REPORT = 50;

// Lead Stage Configuration
export const LEAD_STAGE_CONFIG = [ 
  { statusCode: 'OPEN', title: 'OPEN', icon: <FaFolderOpen />, color: '#20c997' },  
  { statusCode: 'CALLED', title: 'CALLED', icon: <FaPhone />, color: '#007bff'  },  
  { statusCode: 'APPOINTMENTS', title: 'APPOINTMENTS', icon: <FaCalendarCheck />, color: '#6f42c1'},  
  { statusCode: 'VISITED', title: 'VISITED', icon: <FaUserCheck />, color: '#f0ad4e' }, 
  { statusCode: 'QUOTATION', title: 'QUOTATION', icon: <FaFileInvoiceDollar />, color: '#17a2b8' }, 
  { statusCode: 'PROPOSAL', title: 'PROPOSAL SUBMITTED', icon: <FaFileSignature />, color: '#e83e8c'},  
  { statusCode: 'ACCEPTED', title: 'ACCEPTED', icon: <FaCheckCircle />, color: '#28a745'},  
  { statusCode: 'NOT_INTERESTED', title: 'NOT INTERESTED', icon: <FaTimesCircle />, color: '#dc3545'}, 
]

export const MOBILE_REGEX = /^(?:\+|00)[0-9]{13,}$|^0\d{9}$/;
export const EMAIL_REGEX = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
export const FACEBOOK_REGEX = /^(https?:\/\/).+/;
export const NIC_REGEX = /^[A-Za-z0-9]{6,16}$/;

export const REPORT_CONFIG = {
  totalGwp: { filter: true, toMonth: true, download: true},
  gwpProgress: { filter: false, toMonth: true, download: true},
  rider: { filter: false, toMonth: false, download: true},
  premiumPersistency: { filter: true, toMonth: true, download: true},
  mdrt: { filter: false, toMonth: false, download: false},
};

export const PREMIUM_PERSISTENCY_CONFIG = {
  "13M": 85,
  "25M": 82,
  "37M": 80
};